import React, { useEffect, useState } from "react";
import { AppConstants } from "../../constants/AppConstants";
import { LogoContainer, Top } from "./MenuStyles";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
// import { SystemSetting } from "../../app/organizationReducer";
// import { getOrganizationSettings } from "../../http/configuration-services";
// import { getLoggedInOrg } from "../../util/admin-utils";
// import { setOrganizationSetting } from "../../app/organizationReducer";
import { useTranslation } from "react-i18next";
import { HTTP_STATUS } from "../../http/constants/http.status";
import SolutionImg from "../../assets/default/solution.svg";
import { isRTLLanguage } from "../../util/functions";

type Props = {
  children?: React.ReactNode;
  loggedIn?: boolean;
};

const MenuLogo = ({ children, loggedIn = true }: Props) => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const isRTL = isRTLLanguage(i18n.language);

  const useLocalAssets = useAppSelector(
    (state) => state.initialLoadData?.useLocalBanner
  );

  // const organizationSetting: SystemSetting = useAppSelector(
  //   (state) => state.organization.organizationSetting
  // );

  useEffect(() => {
    async function init() {
      // if (!Object.keys(organizationSetting).length) {
      //   let orgData = getLoggedInOrg();
      //   if (orgData) {
      //     let response = await getOrganizationSettings(
      //       orgData.organizationId,
      //       AppConstants.CATEGORY_ORGANIZATION_SETTINGS,
      //       AppConstants.DEFAULT_PAGE,
      //       AppConstants.MAXIMUM_PAGE_SIZE
      //     );
      //     if (response?.data?.data?.length) {
      //       dispatch(setOrganizationSetting(response?.data?.data[0]));
      //     }
      //   }
      // }
    }
    init();
  }, []);

  const logoElement = (
    <LogoContainer>
      {/* <h1>Roche</h1>
      <h2>Admin Portal</h2> organizationSetting?.value?.customizations?.logoURL || */}
      <img
        src={
          !useLocalAssets && loggedIn
            ? AppConstants.getLogoSolutionUrl()
            : SolutionImg
        }
        alt={t("T_GDPR_PORTAL") || ""}
        className="h-3/4 w-3/4 object-contain md:w-full"
      />
    </LogoContainer>
  );

  const childrenElement = loggedIn ? children : "";

  return (
    <Top>
      {/* For RTL: children (language selector) first, then logo */}
      {/* For LTR: logo first, then children (language selector) */}
      {isRTL ? (
        <>
          {childrenElement}
          {logoElement}
        </>
      ) : (
        <>
          {logoElement}
          {childrenElement}
        </>
      )}
    </Top>
  );
};

export default MenuLogo;
